import { Component, OnInit } from '@angular/core';
import { BoobleModalService } from 'booble-modal';

import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { AdminOrderDetailModalComponent } from '../order-details-modal/admin-order-detail-modal.component';
import { NotifierService } from 'angular-notifier';
import { OrdersService } from 'src/app/shared/services/orders.service';

interface OrderPaymentControl {
  order: InboundOrderDto;
  paymentType: 'integral' | 'diferente';
  customValue: number;
  paymentDifference: number;
  differenceSign: string;
}

export interface MassPaymentRequest {
  values: {
    orderId: number;
    valueApprovedPayment: number;
  }[];
}

@Component({
  selector: 'app-mass-payment-confirm',
  templateUrl: './mass-payment-confirm.component.html',
  styleUrls: ['./mass-payment-confirm.component.scss'],
})
export class MassPaymentConfirmComponent implements OnInit {
  boobleModalData: InboundOrderDto[];

  orders: OrderPaymentControl[] = [];
  filteredOrders: OrderPaymentControl[] = [];
  searchText: string = '';
  loading: boolean = false;

  constructor(
    private modalService: BoobleModalService,
    private readonly notifierService: NotifierService,
    private readonly ordersService: OrdersService
  ) {}

  ngOnInit() {
    if (this.boobleModalData) {
      this.orders = this.boobleModalData.map(order => ({
        order,
        paymentType: 'integral' as const,
        customValue: null,
        paymentDifference: 0,
        differenceSign: ''
      }));
      this.filteredOrders = [...this.orders];
    }
  }

  onSearchChange(search: string) {
    if (!search || search.trim() === '') {
      this.filteredOrders = [...this.orders];
      return;
    }

    const searchLower = search.toLowerCase().trim();
    this.filteredOrders = this.orders.filter(item => {
      const orderId = item.order.id?.toString() || '';
      const clientName = this.getClientName(item.order).toLowerCase();
      return orderId.includes(searchLower) || clientName.includes(searchLower);
    });
  }

  getClientName(order: InboundOrderDto): string {
    if (order?.tipoPessoa === 'PJ') {
      return order?.corporateAccount?.companyName || '';
    }
    return order?.individualAccount?.name || '';
  }

  getAmountMN(order: InboundOrderDto): number {
    return order?.quotations?.[0]?.amountMN || 0;
  }

  onPaymentTypeChange(item: OrderPaymentControl) {
    if (item.paymentType === 'integral') {
      item.customValue = null;
      item.paymentDifference = 0;
      item.differenceSign = '';
    }
  }

  onCustomValueChange(item: OrderPaymentControl) {
    const quotedAmount = this.getAmountMN(item.order);
    const approvedValue = item.customValue || 0;
    item.paymentDifference = approvedValue - quotedAmount;
    item.differenceSign = item.paymentDifference > 0 ? '+' : '';
  }

  confirmPayments() {
    // Validar se todos os itens com "diferente" têm valor preenchido
    const hasInvalidItems = this.filteredOrders.some(
      item => item.paymentType === 'diferente' && (!item.customValue || item.customValue === 0)
    );

    if (hasInvalidItems) {
      this.notifierService.notify('error', 'Preencha o valor depositado para todos os itens com valor diferente.');
      return;
    }

    this.loading = true;

    const payload: MassPaymentRequest = {
      values: this.filteredOrders.map(item => ({
        orderId: item.order.id,
        valueApprovedPayment: item.paymentType === 'integral'
          ? this.getAmountMN(item.order)
          : item.customValue
      }))
    };

    this.ordersService.massIdentifyPayment(payload).subscribe({
      next: () => {
        this.loading = false;
        this.notifierService.notify('success', 'Pagamentos confirmados com sucesso.');
        this.ordersService.updateOrderView();
        this.closeModal();
      },
      error: (err) => {
        this.loading = false;
        this.notifierService.notify('error', err?.error?.message || 'Erro ao confirmar pagamentos.');
      }
    });
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  goOrderDetail(orderId: number) {
    this.modalService.present(AdminOrderDetailModalComponent, orderId);
  }
}
